import Skeleton from 'react-loading-skeleton';
import { useBreakpoint } from '~/hooks';

export default function TopSellersLoader() {
  const { mobileScreen } = useBreakpoint();

  return (
    <div className="flex w-full flex-col gap-2x rounded-[16px] bg-blue_light_2 p-2x md:gap-3x md:p-3x">
      <div className="flex items-center justify-between">
        <Skeleton width={180} height={24} containerClassName="leading-none" />
        <div className="hidden gap-x md:flex">
          <Skeleton
            width={32}
            height={32}
            circle
            containerClassName="leading-none"
          />
          <Skeleton
            width={32}
            height={32}
            circle
            containerClassName="leading-none"
          />
        </div>
      </div>
      <div className="flex gap-2x">
        {Array(mobileScreen ? 2 : 5)
          .fill(0)
          .map((_, index) => (
            <div
              key={`top-seller-shimmer-${index}`}
              className="flex flex-1 flex-col items-center gap-x rounded-[12px] border border-gray bg-white p-2x"
            >
              <Skeleton
                width={64}
                height={64}
                borderRadius={8}
                containerClassName="leading-none"
              />
              <Skeleton
                width={100}
                height={16}
                containerClassName="leading-none"
              />
              <Skeleton
                width={60}
                height={16}
                containerClassName="leading-none"
              />
            </div>
          ))}
      </div>
      <Skeleton
        height={40}
        borderRadius={20}
        containerClassName="leading-none md:w-[160px] md:ms-auto"
      />
    </div>
  );
}
